import { MainContext } from "context/mainContext";
import React, { useEffect, useState, useCallback, useContext } from "react";
import { Button } from "reactstrap";

function EVAAnswer({ answer, query, isWelcomeMessage, handleSendEVAStreamMessage, evaResponseError }) {
    const [showMore, setShowMore] = useState(true);
    const { bgColor, textColor } = useContext(MainContext);

    useEffect(() => {
        setShowMore(query?.length === 0);
    }, [query]);

    const handleClick = useCallback(({ href, text }) => {
        handleSendEVAStreamMessage(text)
    }, []);

    const ReformatLine = ({ line }) => {
        
        const handleAnchorClick = (e) => {
            e.preventDefault();
            const href = e.target.getAttribute("href");
            const text = e.target.innerText;
            handleClick({ href, text });
        };

        let formattedLine = line
            .replace(/\n/g, "`nl`")
            .replace(/####(.*?)(`nl`|$)/g, "<h3>$1</h3>")
            .replace(/###(.*?)(`nl`|$)/g, "<h2>$1</h2>")
            .replace(/- *\*\*(.*?)\*\*/g, "<strong>$1</strong>")
            .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
            .replace(
                /<a [^>]*?>(.*?)<\/a>/g,
                (_, text) =>
                  `<a href="#" class="custom-link" style="background: ${bgColor}; color: ${textColor};">${text}</a>`
              )
              
        if (!formattedLine.trim()) formattedLine = "<br>";

        return (
            <span
                dangerouslySetInnerHTML={{ __html: formattedLine }}
                onClick={(e) => {
                    if (e.target.tagName === "A") handleAnchorClick(e);
                }}
            />
        );
    };

    const lines = answer ? answer.split("`nl`") : [];
    const displayedLines = isWelcomeMessage
        ? lines
        : showMore
        ? lines
        : lines.slice(0, 2);

    return (
        evaResponseError ? 
        <div>{answer}</div>
        :
        <div>
            {displayedLines.map((line, index) => (
                <div key={index}>
                    <ReformatLine line={line} />
                </div>
            ))}

            {lines.length > 2 && query?.length > 0 && (
                <div style={{ display: "flex", padding: "10px 0px" }}>
                    <Button
                        color="primary"
                        size="sm"
                        outline
                        onClick={() => setShowMore(!showMore)}
                    >
                        {showMore ? "See less" : "See more"}
                    </Button>
                </div>
            )}
        </div>
    );
}

export default EVAAnswer;
